import { render } from "./InterfaceUsersOnRoute.vue?vue&type=template&id=6437707e&scoped=true"
import script from "./InterfaceUsersOnRoute.vue?vue&type=script&lang=js"
export * from "./InterfaceUsersOnRoute.vue?vue&type=script&lang=js"

import "./InterfaceUsersOnRoute.vue?vue&type=style&index=0&id=6437707e&scoped=true&lang=scss"

import exportComponent from "/tmp/ef98a231-0263-404c-a747-c31ac6c86af7/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6437707e"]])

export default __exports__